import { render, staticRenderFns } from "./StudentRules.vue?vue&type=template&id=2d4ef706&scoped=true&lang=pug&"
import script from "./StudentRules.vue?vue&type=script&lang=js&"
export * from "./StudentRules.vue?vue&type=script&lang=js&"
import style0 from "./StudentRules.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StudentRules.vue?vue&type=style&index=1&id=2d4ef706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4ef706",
  null
  
)

export default component.exports